module.exports = __webpack_public_path__ + "img/hnservices_logo.cf08ee64.png";